<template>
    <div class="modal-unavaliable">
        <b-modal id="unavaliable" title="Avise-me quando chegar" hide-footer no-enforce-focus>
            <div class="modal-unavaliable-description mb-4">
                Preencha o formulário que avisaremos quando chegar este produto.
            </div>
            <ValidationObserver v-slot="{ handleSubmit }" ref="observer" slim>
                <form method="POST" action="#" @submit.prevent="handleSubmit(onSubmit)" class="contact-form pb-3">
                    <ValidationProvider name="nome" rules="required" slim v-slot="{ errors, classes, required }">
                        <div class="form-group">
                            <label for="name" class="modal-unavaliable-label">Nome</label>
                            <input type="text" id="name" class="form-control modal-unavaliable-field" v-model="name" :class="classes">
                            <small v-show="errors[0]" class="text-danger mb-3">{{ errors[0] }}</small>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider name="e-mail" rules="required|email" slim v-slot="{ errors, classes, required }">
                        <div class="form-group">
                            <label for="user_email" class="modal-unavaliable-label">E-mail</label>
                            <input type="text" id="user_email" class="form-control modal-unavaliable-field" v-model="email" :class="classes">
                            <small v-show="errors[0]" class="text-danger mb-3">{{ errors[0] }}</small>
                        </div>
                    </ValidationProvider>
                    <ValidationProvider name="telefone" :rules="{ required: true, regex: /^\(?\d{2}\)?[\s-]?[\s9]?\d{4}-?\d{4}$/  }" slim v-slot="{ errors, classes, required }">
                        <div class="form-group">
                            <label for="phone" class="modal-unavaliable-label">Telefone</label>
                            <the-mask type="text" id="phone" class="form-control modal-unavaliable-field" v-model="phone" :mask="['(##) ####-####', '(##) #####-####']" :masked="true" :class="classes"/>
                            <small small v-show="errors[0]" class="text-danger mb-3">{{ errors[0] }}</small>
                        </div>
                    </ValidationProvider>
                    <recaptcha :data-sitekey="$wdconfig.default.recaptcha_site" v-if="$wdconfig.default.recaptcha"/>
                    <FormMessage :msg="msg_form" :type="msg_form_type"></FormMessage>
                    <button type="submit" class="btn-default btn-square w-100"> {{ sending ? 'Enviando' : 'Enviar' }} </button>
                </form>
            </ValidationObserver>
        </b-modal>
    </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { TheMask } from 'vue-the-mask';
import FormMessage from '~/components/FormMessage';
export default {
    props: {
        product_code: {
            default: 0
        },
        // recaptcha_site: {
        //     default: ''
        // }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        TheMask,
        FormMessage
    },
    data(){
        return{
            name: '',
            email: '',
            phone: '',
            errors:'',
            sending: false,
            msg_form: '',
            msg_form_type: '',
        }
    },
    methods: {
        reset(){
            this.name = '';
            this.email = '';
            this.phone = '';
            requestAnimationFrame(() => {
                this.$refs.observer.reset();
            });
        },
        async onSubmit(){
            this.msg_form = ''
            const params = new URLSearchParams();
            params.append('nome', this.name);
            params.append('email', this.email);
            params.append('telefone', this.phone);
            params.append('metodo', 'adicionar');
            params.append('codigo_produto', this.product_code);
            if (this.$wdconfig.default.recaptcha) {
                params.append('g-recaptcha-response', await this.$recaptcha.getResponse());
            }
            this.sending = true;
            this.$axios.$post('?p=ecommerce_avisequandochegar_api_v1', params)
                .then((response) => {
                    if (response.status === 'sucesso') {
                        this.msg_form = 'Mensagem enviada!';
                        this.msg_form_type = 'success';
                        this.reset();
                    } else {
                        this.msg_form = `Não foi possível enviar: ${response.msg}`;
                        this.msg_form_type = 'error';
                    }
                })
                .catch(function (error) {
                    this.msg_form.text = 'Não foi possível enviar!';
                    this.msg_form.type = 'error';
                    console.error(error);
                })
            if (this.$wdconfig.default.recaptcha) {
                await this.$recaptcha.reset();
            }
        }
    },
    watch: {
        sending(newvalue) {
            if (newvalue) {
                this.msg_form = ''
            }
        },
        msg_form(newvalue) {
            if (newvalue !== '') {
                this.sending = false
            }
        }
    }
}
</script>
